<!-- 页面内容 -->
<template>
    <img
        src="@/assets/images/86.png"
        class="yuyueRoom"
        @load="onImageLoad"
        alt="Lazy Loaded Image"
        @click="$router.push('/home/teacher')"
    />
</template>

<script>
export default {
    data() {
        return {};
    },
    created() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.yuyueRoom {
    width: 150px;
    height: 190px;
    position: fixed;
    right: 32px;
    bottom: 60px;
    z-index: 2;
}
</style>
